import React from 'react';

export default class DateDataType extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<span>{I18n.t(this.props.value)}</span>
			</div>
		);
	}
}
